import { listWorks, getWorks, delWorks, addWorks, updateWorks, listStudentWorksByUserID, listByTecher } from "@/api/OmdWorks/works";
import { listMajors } from "@/api/OmdMajors/majors";
import { listClasses } from "@/api/OmdClasses/classes";
import { listComments, addComments, updateComments } from "@/api/OmdWorkComments/comments";
import { getToseck } from "@/utils/toseck";
import { download } from "@/utils/request";

export default {
  name: "WorkMian",
  data() {
    return {
      // 加载状态
      loading: true,// 初始为true（数据加载中）
      // 选中行的ID数组
      ids: [],
      // 是否单选（用于判断修改按钮状态）
      single: true,
      // 是否多选（用于判断删除按钮状态）
      multiple: true,
      // 是否显示搜索区域
      showSearch: true,
      // 总条数
      total: 0,
      // 作品列表数据
      worksList: [],
      // 专业选项数据
      majorOptions: [],
      // 班级选项数据
      classOptions: [],
      // 对话框标题
      title: "",
      // 是否显示对话框
      open: false,
      // 是否显示评价对话框
      commentOpen: false,
      // // 上传地址
      uploadUrl: process.env.VUE_APP_BASE_API + "/common/upload",
      // // 上传请求头
      headers: { Authorization: "Bearer " + getToseck() },
      userId: sessionStorage.getItem("user"),

      // 查询参数
      queryParams: {
        pageNum: 1,       // 当前页码
        pageSize: 10,     // 每页条数
        nickName: null,   // 学生姓名
        workTitle: null,  // 作品名称
        majorId: null,    // 专业ID
        classId: null,    // 班级ID
        commentLevel: null, // 评价等级
        xueQi: null,//学期
        stage: null//阶段
      },

      // 表单数据
      form: {
        id: null,         // 作品ID
        workTitle: null,  // 作品名称
        majorId: null,    // 专业ID
        classId: null,    // 班级ID
        workScreatetime: null,  // 创作日期
        workMedia: null,   // 作品图片
        xueQi: null,//学期
        stage: null,//阶段
        sortNum: null//排序
      },

      // 评价表单数据
      commentForm: {
        workId: null,     // 作品ID
        nickName: null,   // 学生姓名
        workTitle: null,  // 作品名称
        workMedia: null,  // 作品图片
        commentLevel: null, // 评价等级
        commentContent: null // 评语内容
      },
      // 学期选项
      semesterOptions: [
        { value: '1', label: '第1学期' },
        { value: '2', label: '第2学期' },
        { value: '3', label: '第3学期' },
        { value: '4', label: '第4学期' },
        { value: '5', label: '第5学期' },
        { value: '6', label: '第6学期' }
      ],
      // 阶段选项
      stageOptions: [
        { value: 1, label: '第一阶段' },
        { value: 2, label: '第二阶段' },
        { value: 3, label: '第三阶段' },
        { value: 4, label: '第四阶段' },
        { value: 5, label: '第五阶段' },
        { value: 6, label: '第六阶段' },
        { value: 7, label: '第七阶段' },
        { value: 8, label: '第八阶段' }
      ],

      // 表单验证规则
      rules: {
        workTitle: [
          { required: true, message: "作品名称不能为空", trigger: "blur" }
        ],
        majorId: [
          { required: true, message: "所属专业不能为空", trigger: "change" }
        ],
        classId: [
          { required: true, message: "所属班级不能为空", trigger: "change" }
        ],
        workScreatetime: [
          { required: true, message: "创作日期不能为空", trigger: "change" }
        ],
        workMedia: [
          { required: true, message: "作品图片不能为空", trigger: "change" }
        ]
      },
      // 评价表单验证规则
      commentRules: {
        commentLevel: [
          { required: true, message: "评价等级不能为空", trigger: "change" }
        ],
        commentContent: [
          { required: true, message: "评语内容不能为空", trigger: "blur" }
        ]
      }
    }

  },
  created() {
    // 组件创建时获取数据
    this.getList();
    this.getMajorList();
    this.getClassList();
  },
  computed: {
    identity() {
      return this.$store.state.identity
    },
  },
  methods: {
    /**
     * 获取作品列表
     * @return {void}
     */
    getList() {
      this.loading = true;
      // 添加用户ID参数（如果是学生）
      if (this.identity === 'student') {

        this.queryParams.userId = this.userId;
        listStudentWorksByUserID(this.queryParams).then(response => {
          this.worksList = response.rows;
          this.total = response.total;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      }
    
      else if(this.identity==="admin"){
       
          listWorks(this.queryParams).then(response => {
            this.worksList = response.rows;
            this.total = response.total;
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        
      }
      else{
           this.queryParams.userId = this.userId;
          //  alert(this.queryParams.userId);
           listByTecher(this.queryParams).then(response => {
            this.worksList = response.rows;
            this.total = response.total;
            this.loading = false;
            console.log(this.worksList);
          }).catch(() => {
            this.loading = false;
          });
      }
    
    },

    /**
     * 获取专业列表
     * @return {void}
     */
    getMajorList() {
      listMajors().then(response => {
        this.majorOptions = response.rows;
      }).catch(error => {
        console.error("获取专业列表失败:", error);
      });
    },

    /**
     * 获取班级列表
     * @return {void}
     */
    getClassList() {
      listClasses().then(response => {
        this.classOptions = response.rows;
      }).catch(error => {
        console.error("获取班级列表失败:", error);
      });
    },

    /**
     * 每页条数变化事件
     * @param {number} val 新的每页条数
     * @return {void}
     */
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },

    /**
     * 当前页变化事件
     * @param {number} val 新的页码
     * @return {void}
     */
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },

    /**
     * 取消操作（关闭对话框）
     * @return {void}
     */
    cancel() {
      this.open = false;
      this.reset();
    },

    /**
     * 重置表单
     * @return {void}
     */
    reset() {
      this.form = {
        id: null,
        workTitle: null,
        majorId: null,
        classId: null,
        workScreatetime: null,
        workMedia: null
      };
      // 重置表单验证状态
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },

    /**
     * 搜索操作
     * @return {void}
     */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    /**
     * 重置搜索表单
     * @return {void}
     */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        nickName: null,
        workTitle: null,
        majorId: null,
        classId: null,
        commentLevel: null
      };
      this.handleQuery();
    },

    /**
     * 表格选择项变化事件
     * @param {Array} selection 选中的行数据
     * @return {void}
     */
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },

    /**
     * 新增操作
     * @return {void}
     */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加作品";
    },

    /**
     * 修改操作
     * @param {Object} row 行数据
     * @return {void}
     */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids[0];
      getWorks(id).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改作品";
      }).catch(error => {
        console.error("获取作品详情失败:", error);
      });
    },

    /**
     * 评价操作
     * @param {Object} row 行数据
     * @return {void}
     */
    handleComment(row) {
      this.commentForm = {
        workId: row.id,
        nickName: row.nickName,
        workTitle: row.workTitle,
        workMedia: row.workMedia,
        commentLevel: row.commentLevel || null,
        commentContent: row.commentContent || null
      };
      this.commentOpen = true;
    },

    /**
     * 提交表单
     * @return {void}
     */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          // 根据是否有ID判断是新增还是修改
          const operation = this.form.id ? updateWorks(this.form) : addWorks(this.form);

          operation.then(response => {
            this.$modal.msgSuccess(this.form.id ? "修改成功" : "新增成功");
            this.open = false;
            this.getList();
            console.log(response);
          }).catch(error => {
            console.error("操作失败:", error);
          });
        }
      });
    },

    /**
     * 提交评价表单
     * @return {void}
     */
    submitComment() {
      this.$refs["commentForm"].validate(valid => {
        if (valid) {
          const commentData = {
            workId: this.commentForm.workId,
            teacherId: localStorage.getItem("user"),
            commentLevel: this.commentForm.commentLevel,
            commentContent: this.commentForm.commentContent
          };

          // 先检查是否已有评价，有则更新，无则新增
          listComments({ workId: this.commentForm.workId }).then(res => {
            const operation = res.rows.length > 0
              ? updateComments({ ...commentData, id: res.rows[0].id })
              : addComments(commentData);

            operation.then(response => {
              this.$modal.msgSuccess("评价成功");
              this.commentOpen = false;
              this.getList();
              console.log(response)
            }).catch(error => {
              console.error("评价失败:", error);
            });
          });
        }
      });
    },

    /**
     * 删除操作
     * @param {Object|Number} row 行数据或ID
     * @return {void}
     */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$confirm(`是否确认删除编号为"${ids}"的作品？`, '警告', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'confirm-danger-button',
        cancelButtonClass: 'cancel-button'
      }).then(() => {
        return delWorks(ids);
      }).then(() => {
        this.getList();
        this.$message.success('删除成功');
      }).catch(() => { });
    },

    /**
     * 导出按钮操作
     */
    handleExport() {
      // const queryParams = this.queryParams;
      this.$confirm('是否确认导出所有作品数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        download('/OmdWorks/works/export', {
          ...this.queryParams
        }, `作品_${new Date().toLocaleDateString()}.xlsx`)
      }).then(response => {
        this.download(response.msg);
      }).catch(() => { });
    },

    /**
     * 图片上传成功处理
     */
    handleUploadSuccess(response) {
      this.form.workMedia = response.url;
    }
  }
};